/**
 * Created by gg on 2017/6/16 0016.
 */
(function(smarket, ko, $) {
  if (!smarket || !smarket.api || !smarket.viewModel) {
    throw new Error(
      'Require the smarket module, the smarket.api module, the smarket.template module and the smarket.viewModel module.');
  }

  var smarketSpi = smarket.api,
      filesb = smarketSpi.filesb = smarketSpi.filesb || {};

  var viewModel = smarket.viewModel,
    BaseViewModel = viewModel.BaseViewModel,
    comment = smarket.api.comment;
    function postJSON(url,data,success){
        return smarket.api.s3g(url,data,success);
    }
    comment.interactionCreate=function(data){
        return postJSON('/api/article/interaction/create',data)
    }
    //获取粉丝真实wechatid 下载邮箱用
    filesb.getContact=function(data){
      return postJSON('/api/wechat/contacts/get',data)
    };
    //获取粉丝用户信息 下载邮箱用
    filesb.getWechat = function(data){
      return postJSON('/api/wechat/get',data)
    };
  /**
   * 单条评论信息
   * @param commentItem
   */
  function CommentItem(commentItem) {
    var self = this;
    self.commentId = ko.observable(commentItem.commentId);
    self.createrPic = ko.observable(commentItem.createrPic);
    self.isAnonymous = ko.observable(commentItem.isAnonymous);
    self.creater = ko.observable(commentItem.creater);
    self.province = ko.observable(commentItem.province);
    self.isTop = ko.observable(commentItem.isTop);
    self.isHot = ko.observable(commentItem.isHot);
    self.content = ko.observable(commentItem.content);
    self.timeStr = ko.observable(commentItem.timeStr);
    self.deleted = ko.observable(commentItem.deleted);
    self.like = ko.observable(commentItem.like);
    self.isLike = ko.observable(commentItem.isLike);
    self.isReviewed = ko.observable(commentItem.isReviewed);
  }

  function emojiCN(input) {
    if (typeof input !== 'string') {
      return '[空]';
    }
    var emojiInfos = {
        grinning: '笑', disappointed_relieved: '流汗', heart_eyes: '花痴', fearful: '难过', sob: '哭',
        flushed: '发呆', mask: '感冒', sleeping: '睡觉', cry: '流泪', sweat_smile: '心虚', rage: '愤怒',
        joy: '笑哭', grin: '嘻嘻', hushed: '吃惊', persevere: '折磨', sweat: '尴尬', weary: '痛苦',
        triumph: '生气', blush: '可爱', stuck_out_tongue_winking_eye: '鬼脸', dizzy_face: '衰',
        laughing: '爽', sleepy: '瞌睡', cold_sweat: '伤心', expressionless: '郁闷', smiley: '开心',
        sunglasses: '酷炫', smile: '大笑', no_mouth: '无语', relieved: '满意', pensive: '失落',
        confounded: '难忍', scream: '惊恐', stuck_out_tongue: '吐舌头', kissing_heart: '么么哒', unamused: '嫌弃',
        smirk: '嘚瑟', confused: '不甘', innocent: '天使微笑', wink: '眨眼', stuck_out_tongue_closed_eyes: '快乐',
        anguished: '失望', pig: '猪', joy_cat: '狗狗笑', scream_cat: '狗狗惊呆', grimacing: '呲牙',
        kissing_closed_eyes: '乐呵呵', speak_no_evil: '我不说', see_no_evil: '我不看', hear_no_evil: '我不听',
        beetle: '爬虫', sunny: '太阳', crescent_moon: '晚安', bomb: '炸弹', alien: 'UFO', bear: '熊',
        cow: '奶牛', tea: '咖啡', broken_heart: '心碎', sparkling_heart: '爱心', zan: '强', '-1': '弱',
        clap: '鼓掌', wave: '招收', facepunch: '握拳', muscle: '力量', ok_hand: 'OK', ghost: '幽灵',
        hibiscus: '鲜花', pray: '祈祷', kiss: '飞吻', imp: '暴怒', smiling_imp: '恶魔', rocket: '火箭',
        '100': '一百分', hankey: '便便', lollipop: '棒棒糖', moneybag: '钱钱钱', fire: '火', footprints: '脚丫'
      },
      emojis = [
        '100', 'alien', 'anguished', 'bear', 'beetle', 'blush',
        'bomb', 'broken_heart', 'clap', 'cold_sweat', 'confounded',
        'confused', 'cow', 'cry', 'disappointed_relieved', 'dizzy_face',
        '-1', 'expressionless', 'facepunch', 'fearful', 'fire', 'flushed',
        'ghost', 'grimacing', 'grin', 'grinning', 'hankey', 'hear_no_evil',
        'heart_eyes', 'hibiscus', 'hushed', 'innocent', 'joy_cat', 'joy',
        'kiss', 'kissing_closed_eyes', 'kissing_heart', 'laughing', 'lollipop',
        'mask', 'moneybag', 'muscle', 'no_mouth', 'ok_hand', 'pensive',
        'persevere', 'pig', 'pray', 'rage', 'relieved', 'rocket', 'scream_cat',
        'scream', 'see_no_evil', 'sleeping', 'sleepy', 'smile', 'smiley',
        'smiling_imp', 'imp', 'smirk', 'sob', 'sparkling_heart', 'speak_no_evil',
        'stuck_out_tongue_closed_eyes', 'stuck_out_tongue_winking_eye',
        'stuck_out_tongue', 'sunglasses', 'sunny', 'sweat_smile', 'sweat',
        'tea', 'triumph', 'unamused', 'wave', 'weary', 'wink', 'zan', 'crescent_moon', 'footprints'
      ],
      rEmojis = new RegExp(':(' + emojis.join('|') + '):', 'g');
    return input.replace(rEmojis, function(match, text) {
      return '[' + emojiInfos[text] + ']';
    });
  }

  /**
   * CommentViewModel 创建实例
   * @param options
   * @constructor
   */
  function CommentViewModel(options) {
    var self = this;
    BaseViewModel.apply(self);
    self.options = options;
    self.commentList = ko.observableArray();    //评论列表
    self.start = options.start || 0;
    self.num = options.num || 1000000;
    self.total = ko.observable(0); //评论总条数
    self.commentSetting = ko.observable({
      enableDelete: '',   //是否开启自助删帖
      enableLike: '',     //是否开启点赞
      postIdentity: '',   //发表评论状态
      instanceId: '',     //实例Id
      postIdentityExtra: '',   //注册表单Id
      schemaId: '',       //体系Id
      tplConfigInfo: {},  //前后置接口配置信息项
      trackId: ''         //体系Id
    });
    self.createModalState = ko.observable(false);
    self.isAnonymous = ko.observable(0);
    self.createContent = ko.observable('');
    self.createErrTip = ko.observable('');
    self.createErrTipState = ko.observable(false);
    self.createCommentState = ko.observable(0);
    self.loadingMore = ko.observable(false);
    self.isLoadingMore = ko.observable(false);
    self.pageIndex = 1;
    self.isLoading = ko.observable(false);
  }

  CommentViewModel.prototype = $.extend(true, {}, BaseViewModel.prototype);
  var proto = CommentViewModel.prototype;
  proto.constructor = CommentViewModel;

  //加载数据
  proto.load = function() {
    var self = this;
    self.isLoading(true);
    return self.get();
  };
  //获取评论区
  proto.get = function(start, num) {
    var self = this,
      defer = $.Deferred();
    var isFirstLoad = start === 0 || self.start === 0;
    comment.getList({
      tenantId: self.options.tenantId,
      subVersionId: self.options.subVersionId,
      commentId: 0,
      start: isFirstLoad ? 0 : self.start,
      num: num || self.num,
      topicId: self.options.topicId,
      sess: self.options.session,
      openId: self.options.openId,
      cookieId: self.options.cookieId
    }).then(function(data) {
      var result = data,
        content = result.content;
      if (result.result == 0) {
        var commentList = [];
        for (var key = 0; key < content.items.length; key++) {
          content.items[key].content = emojiCN(content.items[key].content);
          // 去除与现有列表重复的评论在添加
          if (!isFirstLoad && self.commentList().filter(function(element) {
              return element.commentId() === content.items[key].commentId;
            }).length !== 0) {
            continue;
          }
          var commentItem = new CommentItem(content.items[key]);
          commentList.push(commentItem);
        }
        if (data.content.items.length < self.num) {
          self.loadingMore(false);
        }
        else {
          self.loadingMore(true);
        }
        if (!isFirstLoad) {
          commentList = self.commentList().concat(commentList);
        }
        self.commentList(commentList);
        self.total(content.total);
        self.commentSetting(content.topicData);
        defer.resolve(data);
      }
      else {
        defer.reject(data);
      }
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise();
  };

  proto.loadMore = function() {
    var self = this;
    this.isLoadingMore(true);
    self.start = self.pageIndex * self.num;
    self.pageIndex++;
    self.get().always(function() {
      self.isLoadingMore(false);
    });
  };
  // 重置发表状态
  proto.resetCreateModal = function() {
    var self = this;
    self.createContent('');
    self.createErrTip('');
    self.createErrTipState(false);
    self.createCommentState(0);
  };
  //切换发表评论窗口的状态后置空方法
  proto.afterSwitchCreateModalState = function() {
    return true;
  };
  // 切换发表评论窗口的状态
  proto.switchCreateModalState = function() {
    var self = this;
    if (self.commentSetting().postIdentity == 3 && !self.options.memberId && !self.options.session) {
      smarket.initForm({
        identity: self.commentSetting().postIdentity,
        weChatId: self.options.weChatId,
        formId: self.commentSetting().postIdentityExtra,
        trackId: self.commentSetting().trackId,
        schemaId: self.commentSetting().schemaId,
        instanceId: self.commentSetting().instanceId,
        type: smarket.browerType
      }, function(contactInfo) {
        self.createModalState(!self.createModalState());
        self.afterSwitchCreateModalState(contactInfo);
      });
    }
    else {
      self.createModalState(!self.createModalState());
      self.afterSwitchCreateModalState();
    }
  };
  // 发表评论
  proto.createComment = function() {
    var self = this,
      defer = $.Deferred();
    if (self.createCommentState() == 1) {
      defer.reject({desc: '正在发送'});
      return defer.promise();
    }
    self.createCommentState(1);
    if (self.createContent() == '') {
      self.createErrTip('内容不能为空');
      self.createErrTipState(true);
      self.createCommentState(0);
      defer.reject({desc: '内容为空'});
      return defer.promise();
    }
    else if (self.createContent().length > 500) {
      self.createErrTip('内容长度超出限制，请精简后提交');
      self.createErrTipState(true);
      self.createCommentState(0);
      defer.reject({desc: '内容过长'});
      return defer.promise();
    }
    self.isLoading(true);
    self.createContent(self.createContent().replace(/\n+|\r+/g, '<br>').replace(/\s+/g, ' '));
    comment.create({
      topicId: self.options.topicId,
      tenantId: self.options.tenantId,
      nodeId: self.options.tenantId,
      moduleId: self.options.moduleId,
      instanceId: self.options.instanceId,
      isAnonymous: self.isAnonymous(),
      content: self.createContent(),
      commentId: 0,
      openId: self.options.openId,
      cookieId: self.options.cookieId,
      nickname: self.options.nickname,
      createrPic: self.options.headimgurl,
      createrLocation: self.options.createrLocation,
      subVersionId: self.options.subVersionId,
      sess: self.options.session,
      title: self.options.title,
      weChatId: self.options.sourceWeChatId,
      browseInfo: activeRecord.browseInfo
    }).then(function(data) {
      if (!!data.content) {
        self.resetCreateModal();
        self.get(0, self.num).always(function() {
          self.pageIndex = 1;
          self.isLoading(false);
        });
        defer.resolve(data);
      }
      else {
        defer.reject(data);
      }
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise();
  };
  // 删除评论
  proto.deleteComment = function(commentItem) {
    var self = this,
      defer = $.Deferred();
    self.isLoading(true);
    comment.delete(self.options.topicId, self.options.openId, self.options.cookieId, commentItem.commentId(),
      self.options.session).then(function(data) {
      if (!!data.content) {
        self.commentList(self.commentList().filter(function(element) {
          return element.commentId() !== commentItem.commentId();
        }));
        self.total(self.total() - 1);
        self.isLoading(false);
        defer.resolve(data);
      }
      else {
        defer.reject(data);
      }
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise();
  };
  // 评论点赞
  proto.likeComment = function(commentItem) {
    var self = this,
      defer = $.Deferred();
    if (commentItem.isLike() == 0) {
      defer.reject({desc: '重复点赞'});
      return defer.promise();
    }
    commentItem.isLike(0);
    commentItem.like(Number(commentItem.like()) + 1);
    comment.like([commentItem.commentId()], self.options.memberId, self.options.openId, self.options.cookieId,
      self.options.session).then(function(data) {
      if (!!data.content) {
        defer.resolve(data);
      }
      else {
        defer.reject(data);
      }
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise();
  };

  function addBowerInfo(url, data) {
    if (!('browseInfo' in data)) {
      data.browseInfo = activeRecord.browseInfo;
    }
  }

  var urlItems = ['/comment/like','/article/like', '/article/getListByProject','/file/downloadWithEmail'];
  smarket.registerRulesListHandler(addBowerInfo, urlItems);

    function addWeChatId(url, data) {
        if (!('weChatId' in data)) {
            data.weChatId = smarket.urlParams.weChatId;
        }
    }

  var ual=['/article/getDetail']
    smarket.registerRulesListHandler(addWeChatId, ual);

  //重写CommentViewModel
  CommentViewModel.extend = function(_proto) {
    $.each(_proto, function(idx, val) {
      proto[idx] = val;
    });
  };
  viewModel.CommentViewModel = CommentViewModel;
})(smarket, ko, $);